import { Interpolation, Theme } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { BannerNotification } from '@frontend/design-system';

type Props = {
  isInsuranceDetailsWritebackSupported: boolean;
  isDemoOffice?: boolean;
  css?: Interpolation<Theme>;
};

export const ManualVerificationSuccessBanner = ({
  isInsuranceDetailsWritebackSupported,
  isDemoOffice = false,
  ...rest
}: Props) => {
  const { t } = useTranslation('insuranceDetails');
  const shouldShowSimpleSuccessMessage = isInsuranceDetailsWritebackSupported || isDemoOffice;
  const message = shouldShowSimpleSuccessMessage
    ? t('Verification successful.')
    : t('Verification successful. However, updated insurance data will not be synced with the EHR.');
  const status = shouldShowSimpleSuccessMessage ? 'success' : 'info';
  return <BannerNotification {...rest} status={status} message={message} />;
};
